import React from 'react';

const SuccessMessage = ({ className, children , style }) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: '#75BD2F',
                fontFamily: 'Poppins,sans-serif',
                fontSize: '16px',
                fontWeight: 500,
                ...style,
            }}
            className={className}
        >
            {children}
        </div>
    );
};

export default SuccessMessage;
